import { createContext, useContext, type ReactNode } from "react";
import { useStatus, type StatusContextValue } from "./status";

const Ctx = createContext<StatusContextValue | null>(null);

/**
 * One poller for the whole app.
 *
 * The nav badge and the Stack view both need the snapshot; without a shared
 * provider they would each poll, doubling the load on the *arr instances for no
 * new information.
 */
export function StatusProvider({ children }: { children: ReactNode }) {
  const value = useStatus(10_000);
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export function useSharedStatus(): StatusContextValue {
  const v = useContext(Ctx);
  if (!v) throw new Error("useSharedStatus must be used inside <StatusProvider>");
  return v;
}
